import React from 'react';
import PropTypes from 'prop-types';
import { isNumber } from 'lodash';
import MoneyDisplay from '../../../../components/money-display';
import HistoryLogsWrapper from '../../../../components/history-logs-wrapper';

function ForecastAmountRenderer(props) {
  const { value, data, node } = props;
  const isGrouped = node && node.group;
  let val = value;
  if (value === null) {
    return null;
  }
  if (!isNumber(val)) {
    val = Math.ceil(value.value); // b/c of average func
  }
  const amountComp = (<MoneyDisplay value={val} precision={1} abbreviated />);
  if (isGrouped) {
    // groupping
    return amountComp;
  }

  let suffixComp = null;
  if (data && !Number.isNaN(data.delta_amount) && data.delta_amount !== 0) {
    const isNegative = data.delta_amount < 0;
    const isPossitive = data.delta_amount > 0;
    let labelCls = 'label-default';
    if (isNegative) {
      labelCls = 'label-danger';
    } else if (isPossitive) {
      labelCls = 'label-success';
    }
    suffixComp = (
      <span>
        &nbsp;<span className={`label ${labelCls}`}><MoneyDisplay value={data.delta_amount} precision={1} abbreviated withPlus /></span>
      </span>
    );
  }
  
  return (
    <HistoryLogsWrapper type="amount" opportunity={data}>
      {amountComp}{suffixComp}
    </HistoryLogsWrapper>
  );
}

ForecastAmountRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.number,
    }),
  ]),
  data: PropTypes.shape({
    delta_amount: PropTypes.number,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
ForecastAmountRenderer.defaultProps = {
  value: null,
  node: null,
  data: null,
};

export default ForecastAmountRenderer;